module.exports = __webpack_public_path__ + "img/0-132.4f2882a9.jpg";